import { RECEIVE_ENQUIRIES, CHANGE_STATUS, ADD_ENQUIRY_COMMENT } from '../actions/enquiries'

export default function enquiries (state = {}, action) {
	switch (action.type) {
		case RECEIVE_ENQUIRIES :
			return action.enquiries === null
				? {}
				: {
					...state,
					...action.enquiries
				}

		case CHANGE_STATUS :
			return {
        ...state,
        [action.id]: {
          ...state[action.id],
          statusId: action.statusId
        }
			}

		case ADD_ENQUIRY_COMMENT :
			return {
        ...state,
        [action.id]: {
          ...state[action.id],
          comments: state[action.id].comments.concat(action.comment)
        }
			}

		/*case ADD_QUESTION :
			const { question } = action

			return {
				...state,
				[question.id]: question
			}*/

		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/reducers/enquiries.js